import { ChangeEvent, FC, useRef, useState } from "react";

import {
  BackButtonContainer,
  GreenHeader,
  RedHeader,
  SpreadButtonContainer,
} from "../../../global.styles";
import RadioButton from "../../UI/radio-buttons/radio-button";
import { StyledTextArea } from "../../UI/textarea/textarea.component";
import useAutosizeTextArea from "../../UI/textarea/useAutosizedTextArea";
import FormInput from "../../UI/form-input/form-input.component";
import Button from "../../UI/button/button.component";
import Spinner from "../../UI/spinner/spinner.component";
import { sendEmailsToDrivers } from "../../../firebase/admin";

//props types
type SendBulkEmailsProps = {
  onSuccess: (success: boolean) => void;
};

const SendBulkEmails: FC<SendBulkEmailsProps> = ({ onSuccess }) => {
  const [driversGroup, setDriversGroup] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailText, setEmailText] = useState("");
  const [sendEmailsError, setSendEmailsError] = useState("");
  const [sendEmailsSuccessMessage, setSendEmailsSuccessMessage] = useState("");
  const [sendEmailsLoading, setSendEmailsLoading] = useState(false);

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  useAutosizeTextArea(textAreaRef.current, emailText);

  const driversGroupChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setDriversGroup(event.target.value);
  };

  const changeEmailTextHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setEmailText(event.target.value);
  };

  const clearForm = () => {
    setDriversGroup("");
    setEmailSubject("");
    setEmailText("");
    setSendEmailsError("");
    setSendEmailsLoading(false);
  };
  const sendEmailHandler = async () => {
    // check if driversGroup is selected
    if (!driversGroup) {
      setSendEmailsError("Please select a drivers group.");
      return;
    }
    // check if email subject is empty
    if (!emailSubject) {
      setSendEmailsError("Please enter a subject.");
      return;
    }
    // check if email text is empty
    if (!emailText) {
      setSendEmailsError("Please enter email text.");
      return;
    }
    // send emails
    setSendEmailsLoading(true);
    setSendEmailsError("");
    setSendEmailsSuccessMessage("");
    try {
      const data = await sendEmailsToDrivers({ driversGroup, emailSubject, emailText });
      setSendEmailsSuccessMessage(data.message);
      clearForm();
    } catch (error) {
      if (error instanceof Error) {
        setSendEmailsError(error.message);
      } else {
        setSendEmailsError("Error sending emails. Please try again. Maybe not...");
      }
    } finally {
      setSendEmailsLoading(false);
    }
  };

  if (sendEmailsLoading) return <Spinner />;

  if (sendEmailsSuccessMessage && sendEmailsSuccessMessage.length > 0)
    return (
      <>
        <GreenHeader>{sendEmailsSuccessMessage}</GreenHeader>
        <BackButtonContainer>
          <Button
            buttonType="green"
            onClick={() => onSuccess(false)}
          >
            OK
          </Button>
        </BackButtonContainer>
      </>
    );

  return (
    <>
      <GreenHeader>Send emails to:</GreenHeader>
      <RadioButton
        label="Active Drivers"
        id="activeDrivers"
        name="driversGroup"
        value="activeDrivers"
        onChange={driversGroupChangeHandler}
        checked={driversGroup === "activeDrivers"}
      />
      <RadioButton
        label="All Drivers ever registered"
        id="allDrivers"
        name="driversGroup"
        value="allDrivers"
        onChange={driversGroupChangeHandler}
        checked={driversGroup === "allDrivers"}
      />
      <FormInput
        label="Subject"
        id="email-subject"
        type="text"
        onChange={(event) => setEmailSubject(event.target.value)}
        value={emailSubject}
        required
      />
      <StyledTextArea
        id="review-text"
        onChange={changeEmailTextHandler}
        placeholder="Email Text Here..."
        ref={textAreaRef}
        rows={1}
        value={emailText}
        required
      />
      {sendEmailsError && <RedHeader>{sendEmailsError}</RedHeader>}
      <SpreadButtonContainer>
        <Button buttonType="inverted" onClick={clearForm}>
          Clear
        </Button>
        <Button onClick={sendEmailHandler}>Send</Button>
      </SpreadButtonContainer>
    </>
  );
};

export default SendBulkEmails;
